import styled from 'styled-components'
import theme from 'theme_'

export const AboutCompanyWrapper = styled.div`
  color: ${theme.colors.duneWarmGrey};
  padding: 32px 40px;

  @media ${theme.devices.mobile} {
    padding: 16px;
    padding-top: 0;
  }
`

export const AboutCompanyPanel = styled.div`
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px;
  padding-bottom: 36px;
  @media ${theme.devices.tablet} {
    padding: 48px;
  }
  @media ${theme.devices.mobile} {
    padding: 24px;
  }
`

export const AboutCompanyInfo = styled.div`
  display: flex;
  gap: 20px;

  @media ${theme.devices.mobile} {
    flex-direction: column;
  }
`

export const AboutCompanyPageHeader = styled.h1`
  color: ${theme.colors.otterWarmBlack};
  font-style: normal;
  font-weight: bold;
  font-size: 24px;

  @media ${theme.devices.mobile} {
    margin: 8px 0;
    line-height: 32px;
  }
`

export const AboutCompanyNameHeader = styled.h2`
  color: ${theme.colors.otterWarmBlack};
  font-size: 40px;
  font-weight: bold;
  margin: 0;
  margin-bottom: 32px;
`

export const AboutCompanyDisclaimer = styled.p`
  color: ${theme.colors.moreGrey};
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  margin-top: 32px;

  @media ${theme.devices.tablet} {
    width: 80%;
  }
  @media ${theme.devices.desktop} {
    width: 45%;
  }
  @media ${theme.devices.mobile} {
    width: 100%;
  }
`

export const CompanyDetail = styled.span`
  font-weight: bold;
`

export const CompanyImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media ${theme.devices.mobile} {
    justify-content: center;
  }
`

export const CompanyImageUploadInput = styled.input`
  display: none;
`
